<template>
  <div class="row">
    <div class="col-12 col-md-12">
      <div class="row">
        <div class="col-12 col-md-6">
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label>
                Departamento:
                <span class="text-danger lb-error" v-if="!$v.domicilio.departamento.required">* Campo requerido</span>
              </label>
              <select
                class="form form-control"
                :class="{'is-invalid': $v.domicilio.departamento.$error}"
                v-model="$v.domicilio.departamento.$model"
                @change="onChangeDepartamento($event)"
              >
                <option value="">SELECCIONAR</option>
                <option v-for="(item, index) in departamentos" :value="item.codigo_departamento" :key="index">{{item.nombre_departamento}}</option>
              </select>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label>
                Empresa:
                <span class="text-danger lb-error" v-if="!$v.domicilio.id_empresa.required">* Campo requerido</span>
              </label>
              <select
                class="form form-control"
                :class="{'is-invalid': $v.domicilio.id_empresa.$error}"
                v-model="$v.domicilio.id_empresa.$model"
                @change="onChangeEmpresa($event)"
              >
                <option value="">SELECCIONAR</option>
                <option v-for="(item, index) in empresas" :key="index" :value="item.id_empresa">{{ item.emp_razon_social }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6">
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label>
                Fecha Inicio:
                <span class="text-danger lb-error" v-if="!$v.domicilio.fecha_inicio.required">* Campo requerido</span>
              </label>
              <input
                type="date"
                class="form form-control"
                :class="{'is-invalid': $v.domicilio.fecha_inicio.$error}"
                :min="fechaMin"
                v-model="$v.domicilio.fecha_inicio.$model"
                @change="onChangeFechaIni($event)"
              />
            </div>
          </div>
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label>
                Fecha Fin:
                <span class="text-danger lb-error" v-if="!$v.domicilio.fecha_fin.required">* Campo requerido</span>
              </label>
              <input
                type="date"
                class="form form-control"
                id="fecha_fin"
                :class="{'is-invalid': $v.domicilio.fecha_fin.$error}"
                :min="fechaMin"
                v-model="$v.domicilio.fecha_fin.$model"
              />
            </div>
          </div>
          
        </div>
        
        <div class="col-12 col-md-6" v-show="existeEmpresa">
          <div class="row form-group">
            <div class="col-12 col-md-12">
              <label>
                Nombre empresa:
              </label>
              <input
                  type="text"
                  placeholder="Nombre empresa..."
                  v-model.trim="domicilio.nombre_domicilio"
                  class="form-control"
                  @keyup="domicilio.nombre_domicilio = domicilio.nombre_domicilio.toUpperCase()"
                />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

  

</template>

<script>
import {required} from "vuelidate/lib/validators";
import moment from 'moment';

export default {
  props:{
    domicilio: Object
  },
  data() {
    return {
      empresas: [],
      departamentos: [],
      fechaMin: new moment().format("YYYY-MM-DD"),
      existeEmpresa : false
    }
  },
  methods: {
    async getDepartamentos() {
      let config = { headers: { token: this.token } };
      try {
        await this.axios.get(`/getDepartamentos`, config)
        .then((response) => {
          this.departamentos = response.data.contenido;
        })
        .catch((error) => {
          console.log('catch: ', error);
        });
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    // async getEmpresasHospedaje() {
    //   try {
    //     let resultado = await this.axios.get(`/empresa/empresaByRubro/3`);
    //     this.empresas = resultado.data.contenido;
    //   } catch (error) {
    //     console.log('catch: ', error);
    //   }
    // },
    async onChangeDepartamento(event){
      try {
        let departamento = event.target.options[event.target.selectedIndex].value;
        this.domicilio.departamento = departamento;
        //console.log(departamento);
        let resultado = await this.axios.get(`/getEmpresa/${departamento}`);
        this.empresas = resultado.data.contenido;
        if(this.empresas.lenght == "" || this.empresas == undefined){
          this.empresas = [];
        }
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    onChangeEmpresa(event){
      try {
        this.domicilio.id_empresa = event.target.options[event.target.selectedIndex].value;
        let empresa = event.target.options[event.target.selectedIndex].text;
        this.domicilio.nombre_domicilio = empresa;
        this.domicilio.empresa_persona = 0;
        if(empresa == 'EMPRESA NO SE ENCUENTRA REGISTRADA'){
          this.existeEmpresa = true;
          this.domicilio.empresa_persona = 1;
          this.domicilio.nombre_domicilio = "";
        }else{
          this.existeEmpresa = false;
          this.domicilio.empresa_persona = 0;
        }
      } catch (error) {
        console.log('catch: ', error);
      }
    },
    onChangeFechaIni(event){
      let fecha = event.target._value;
      document.getElementById("fecha_fin").setAttribute("min",fecha);
    },

  },
  created () {
    this.getDepartamentos();
  },
  validations: {
    domicilio: {
      departamento: { required },
      id_empresa: { required },
      fecha_inicio: { required },
      fecha_fin: { required },
    },
  },

}
</script>
